module.exports = __webpack_public_path__ + "static/media/indian-black-doctor.437dc183.jpg";